import React from 'react';
import {Line} from 'react-chartjs-2';


class AreaChart extends React.Component {

    render() {
        return (
            <div>
                {this.props.chartData ? <Line data={this.props.chartData} options={this.props.chartOptions} /> : null }
            </div>
        );
    }
}

AreaChart.propTypes = {

}

export default AreaChart;


/** WEBPACK FOOTER **
 ** ./src/components/areaChart.js
 **/